import atticusLogoFullDark from "../../assets/logos/atticus_animated.gif";
import atticusLogoSmallDark from "../../assets/logos/atticus_small_animated.gif";
import { Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { scroller } from "react-scroll";
import {
  Dialog,
  DialogPanel,
  PopoverGroup,
} from "@headlessui/react";
import { Bars3Icon, XMarkIcon } from "@heroicons/react/24/outline";

export default function TopNav() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();

  // Smooth-scroll to sections if a hash is present in the URL
  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      scroller.scrollTo(hash.substring(1), {
        smooth: true,
        duration: 500,
        offset: -70,
      });
    } else {
      scroller.scrollTo("top", {
        smooth: true,
        duration: 500,
        offset: 0,
      });
    }
  }, [location]);

  return (
    <header className="bg-white shadow-md sticky top-0 z-20">
      <nav
        aria-label="Global"
        className="mx-auto flex max-w-7xl items-center justify-between p-6 lg:px-8"
      >
        <div className="flex lg:flex-1 items-center">
          <Link to={"/home"} className="-m-1.5 p-1.5">
            <span className="sr-only">Atticus Labs</span>
            <img
              alt="Atticus Labs Logo"
              src={atticusLogoSmallDark}
              className="h-16 w-auto"
            />
          </Link>
          <span className="ml-2 text-gray-600 font-bold text-lg">
            Atticus Labs
          </span>
        </div>
        <div className="flex lg:hidden">
          <button
            type="button"
            onClick={() => setMobileMenuOpen(true)}
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-600"
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon aria-hidden="true" className="h-6 w-6" />
          </button>
        </div>
        <PopoverGroup className="hidden lg:flex lg:gap-x-12">
          <button
            onClick={() => scroller.scrollTo('why-choose-us', { smooth: true, duration: 500, offset: -70 })}
            className="text-sm font-semibold leading-6 text-gray-600 hover:text-atticusPink-600 transition-colors duration-200"
          >
            Why Us
          </button>
          <button
            onClick={() => scroller.scrollTo('services', { smooth: true, duration: 500, offset: -70 })}
            className="text-sm font-semibold leading-6 text-gray-600 hover:text-atticusPink-600 transition-colors duration-200"
          >
            How We Work
          </button>
          <button
            onClick={() => scroller.scrollTo('contact', { smooth: true, duration: 500, offset: -70 })}
            className="text-sm font-semibold leading-6 text-gray-600 hover:text-atticusPink-600 transition-colors duration-200"
          >
            Contact
          </button>
        </PopoverGroup>
      </nav>

      {/* Mobile Menu */}
      <Dialog
        open={mobileMenuOpen}
        onClose={setMobileMenuOpen}
        className="lg:hidden"
      >
        <div className="fixed inset-0 z-10" />
        <DialogPanel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
          <div className="flex items-center justify-between">
            <Link to={"/home"} className="-m-1.5 p-1.5">
              <span className="sr-only">Atticus Labs</span>
              <img
                alt="Atticus Labs Logo"
                src={atticusLogoSmallDark}
                className="h-12 w-auto"
              />
            </Link>
            <button
              type="button"
              onClick={() => setMobileMenuOpen(false)}
              className="-m-2.5 rounded-md p-2.5 text-gray-600"
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon aria-hidden="true" className="h-6 w-6" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            <div className="-my-6 divide-y divide-gray-500/10">
              <div className="space-y-2 py-6">
                <button
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-600 hover:bg-gray-50 w-full text-left"
                  onClick={() => {
                    setMobileMenuOpen(false);
                    scroller.scrollTo('why-choose-us', { smooth: true, duration: 500, offset: -70 });
                  }}
                >
                  Why Us
                </button>
                <button
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-600 hover:bg-gray-50 w-full text-left"
                  onClick={() => {
                    setMobileMenuOpen(false);
                    scroller.scrollTo('services', { smooth: true, duration: 500, offset: -70 });
                  }}
                >
                  How We Work
                </button>
                <button
                  className="-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-600 hover:bg-gray-50 w-full text-left"
                  onClick={() => {
                    setMobileMenuOpen(false);
                    scroller.scrollTo('contact', { smooth: true, duration: 500, offset: -70 });
                  }}
                >
                  Contact
                </button>
              </div>
            </div>
          </div>
        </DialogPanel>
      </Dialog>
    </header>
  );
}
